import { createContext, useContext } from 'react';
import type { SurveyForm } from '../types';

interface BuilderContextValue {
  form: SurveyForm;
  setForm: React.Dispatch<React.SetStateAction<SurveyForm>>;
  enfoqueFilter: 'all' | 'individual' | 'colectivo';
  setEnfoqueFilter: (f: 'all' | 'individual' | 'colectivo') => void;
  source?: 'surveys' | 'templates';
}

const BuilderContext = createContext<BuilderContextValue | null>(null);

export { BuilderContext };

export function useBuilderContext(): BuilderContextValue {
  const ctx = useContext(BuilderContext);
  if (!ctx) throw new Error('useBuilderContext must be used inside SurveyBuilderView');
  return ctx;
}
